import React from "react";
import { AccessTime, InfoOutlined, Store } from "@mui/icons-material";
import { Box, Grid } from "@mui/material";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import { useBranchTallyUploadDetailContext } from "contexts/BranchTallyUploadDetailContext";
import { localizeDateTimeShort } from "utils/dateFormats";

const BranchTallyUploadBasicDetail = () => {
  const { branchTallyUploadDetail, loadingBranchTallyUpload } =
    useBranchTallyUploadDetailContext();

  return !loadingBranchTallyUpload ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <InformationTile icon={() => <Store color="primary" />} title="Branch" subtitle={branchTallyUploadDetail?.branch?.name || "N/A"} />
        </Grid>
        <Grid item xs={12} md={4}>
          <InformationTile icon={() => <InfoOutlined color="primary" />} title="Uploaded By" subtitle={branchTallyUploadDetail?.uploadedBy?.name || branchTallyUploadDetail?.uploadedBy?.email || "N/A"} />
        </Grid>
        <Grid item xs={12} md={4}>
          <InformationTile icon={() => <InfoOutlined color="primary" />} title="Updated By" subtitle={branchTallyUploadDetail?.updatedBy?.name || branchTallyUploadDetail?.updatedBy?.email || "N/A"} />
        </Grid>
        <Grid item xs={12} md={4}>
          <InformationTile icon={() => <AccessTime color="primary" />} title="Created Date" subtitle={localizeDateTimeShort(branchTallyUploadDetail?.createdAt)} />
        </Grid>
        <Grid item xs={12} md={4}>
          <InformationTile icon={() => <AccessTime color="primary" />} title="Updated Date" subtitle={branchTallyUploadDetail?.updatedAt ? localizeDateTimeShort(branchTallyUploadDetail.updatedAt) : "-"} />
        </Grid>
      </Grid>
    </Box>
  ) : <InfoGridSkeleton />;
};

export default BranchTallyUploadBasicDetail;
